// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import Opponents from './components/Opponents'
import About from './components/About'

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{path:'/', component: Opponents},
		{path:'/about', component: About}
	]
});

new Vue({
  router,
  template: `<div id="app"> 
  				<div class="menu">
					<router-link to="/">Calculator</router-link>
					<router-link to="/about">About</router-link>
				</div>
			<router-view></router-view>
		</div>
		`,
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js